import React from 'react';
import _ from 'lodash';
import { FormHelperText, TextField } from '@material-ui/core';

const FormikInput = ({ field: { ...fields }, form: { touched, errors, setFieldValue }, ...props }): React.ReactNode => {
    const { id, maxLength, onChange, isDefaultValue, hasObject = false, multiline, ...rest } = props;
    const error = Boolean(_.get(touched, fields.name) && _.get(errors, fields.name));
    const getError = () => {
        let errorString = errors;
        fields?.name?.split('.').map((name) => (errorString = errorString[name]));
        return errorString;
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (onChange) {
            onChange(e);
            return;
        }

        const val = e.target.value;

        if (props.type === 'number') {
            setFieldValue(fields?.name, val === '' ? null : Number(val));
        } else {
            setFieldValue(fields?.name, val);
        }
    };

    return (
        <>
            {isDefaultValue ? (
                <TextField
                    variant="outlined"
                    {...fields}
                    {...rest}
                    fullWidth
                    multiline={multiline}
                    id={id}
                    onChange={handleChange}
                    error={error}
                    inputProps={
                        multiline
                            ? { maxLength: maxLength ? maxLength : 450 }
                            : {
                                  maxLength: maxLength ? maxLength : 50,
                              }
                    }
                    helperText={error && errors[fields.name]}
                />
            ) : (
                <TextField
                    variant="outlined"
                    {...fields}
                    {...rest}
                    fullWidth
                    multiline={multiline}
                    id={id}
                    error={error}
                    onChange={handleChange}
                    value={props.type === 'number' ? fields?.value || 0 : fields?.value?.toString()?.trimStart() || ''}
                    inputProps={
                        multiline
                            ? { maxLength: maxLength ? maxLength : 450 }
                            : {
                                  maxLength: maxLength ? maxLength : 50,
                              }
                    }
                    helperText={error && errors[fields.name]}
                />
            )}
            {hasObject && (
                <FormHelperText error>{error && (hasObject ? getError() : errors[fields?.name])}</FormHelperText>
            )}
        </>
    );
};
export default FormikInput;
